import { useEffect, useRef } from 'react';
import { BehaviorSubject } from 'rxjs';
import { useRefFn } from './helpers';
export function useObservable(init, inputs) {
    if (!inputs) {
        return useRefFn(init).current;
    }
    const inputs$Ref = useRefFn(() => new BehaviorSubject(inputs));
    const source$Ref = useRefFn(() => init(inputs$Ref.current));
    const firstRef = useRef(true);
    useEffect(() => {
        if (firstRef.current) {
            // skip first round
            firstRef.current = false;
            return;
        }
        inputs$Ref.current.next(inputs);
    }, inputs);
    return source$Ref.current;
}
//# sourceMappingURL=use-observable.js.map